
import axios from "axios";
import { HTTP } from "@/utils/http-common";
import Vue from "vue";
export default Vue.extend({
  name: "ContactForm",
  data() {
    return {
      varToSend: {
        local_address: "",
        local_name: "",
        email: "",
        web_address: "",
        social_media: "",
        local_content: "",
        local_discount: "",
        coupon_description: "",
        idea: "",
        local_logo: "",
      },
      files: [],
      isLoadLogo: false,
      formAccepted: false,
      isLoadImage: false,
      isLoading: false,
      loading: false,
      formError: false,
      longAgreement: false,
    };
  },
  methods: {
    sendMail() {
      this.loading = true;
      this.isLoading = true;
      const formData = new FormData();
      for (const getKeyValue in this.varToSend) {
        if (this.varToSend.hasOwnProperty(getKeyValue)) {
          Object.keys(this.varToSend).map((k, i) => {
            const d = Object.values(this.varToSend)[i];
            formData.set(k, d);
          });
        }
      }
      formData.set("agreement", "TAK");
      const name = "name";
      [...this.files].forEach((file) => {
        formData.set(file[name], file);
      });
      HTTP.post(
        "https://rckik-katowice.pl/form-carter/index.php",
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          this.formAccepted = true;
          this.isLoading = false;
          if (response.data.data.message === "OK") {
            for (const key in this.varToSend) {
              if (this.varToSend.hasOwnProperty(key)) {
                (this.varToSend as any)[key] = "";
              }
            }
          } else {
            this.formError = true;
          }
          this.loading = false;
        })
        .catch((e) => {
          this.formError = true;
          this.loading = false;
        });
    },
    showFullAgreement() {
      this.longAgreement = !this.longAgreement;
    },
    image(event: { target: { files: any } }) {
      this.files = event.target.files;
      this.isLoadImage = true;
    },
    logo(event: { target: { files: any } }) {
      if (event.target.files[0].size <= 10000000) {
        this.varToSend.local_logo = event.target.files[0];
        this.isLoadLogo = true;
      }
    },
  },
});
